import { Injectable } from '@angular/core';
import { PermissionsService } from '@app/modules/auth';
import { Division } from '@app/modules/auth/models/core-company-api.model';
import { Observable, map, combineLatest } from 'rxjs';
import { EnvironmentService } from './environment.service';

export interface DivisionMap {
  [key: string]: Division;
}
@Injectable({ providedIn: 'root' })
export class DivisionMappingService {
  divisionMap: DivisionMap;

  constructor(private permissionsService: PermissionsService, private envService: EnvironmentService) {
    this.permissionsService.divisionMap$.subscribe(divisionMap => {
      this.divisionMap = divisionMap;
    });
  }

  // an observable to get all the possible division ids asyncronously
  public getActiveDivisionIds$(): Observable<string[]> {
    return combineLatest([this.permissionsService.divisionMap$, this.permissionsService.getUserProfiles()]).pipe(
      map(([divisionMap, userProfiles]) => {
        const hasAdminProfile = userProfiles.some(p => {
          return (
            p.applicationId === this.envService.getEnvironmentProperty('auth').applicationId && p.divisions.length === 0
          );
        });

        this.divisionMap = divisionMap;
        if (hasAdminProfile) {
          return [];
        }
        return this.getActiveDivisions().map(d => d.id);
      })
    );
  }

  public getActiveDivisions(): Division[] {
    return Object.values(this.divisionMap); //.filter(division => division.status === 'ACTIVE');
  }

  // public getChildDivisionsForParentIds(parentIds: string[]): Division[] {
  //   return this.getActiveDivisions().filter(division => parentIds.includes(division.parentId));
  // }

  public getDivisionsForIds(divisionIds: string[]): Division[] {
    return this.getActiveDivisions().filter(division => divisionIds.includes(division.id));
  }

  private _getMatchingDivison = divisionId => {
    return Object.values(this.divisionMap).find(division => {
      if (division.id === divisionId) {
        return true;
      }
      return false;
    });
  };

  public getLocationNameById(divisionId) {
    let matchingDivision;
    // need this if/else statement in case a user goes immediately to /assets/:id, the permissions have not been set yet due to async timing
    if (this.divisionMap) {
      matchingDivision = this._getMatchingDivison(divisionId);
    } else {
      this.permissionsService.divisionMap$.subscribe(divisionMap => {
        this.divisionMap = divisionMap;
        matchingDivision = this._getMatchingDivison(divisionId);
      });
    }

    return matchingDivision?.name || null;
  }
}
